import { Route } from '@angular/router';
import { OccupationsListComponent } from './ui/occupations-list/occupations-list.component';

const occupationsRoutes: Route[] = [
    {
        path: 'occupations',
        component: OccupationsListComponent,
    },
];

export default occupationsRoutes;
